export default "__VITE_ASSET__4bs2i4DI__"